import React from 'react'
import { Row, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import TermsCard from '../../components/Terms/TermsCard.jsx'
import TermsChars from '../../components/Terms/TermsChars.jsx'
import Question from '../../components/Terms/Question.jsx'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
const cookies = new Cookies()

class Terms extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            terms: [],
            faq: [],
            termsLoaded: false,
            faqLoaded: false,
        }
    }

    getFaq(data) {
        api.getFaq(data)
            .then((faq) => this.setState({ faq, faqLoaded: true }))
            .catch((e) => processError(e, this.props.history))
    }

    getTerms(lang, accessToken) {
        api.getTerms(lang, accessToken)
            .then((res) => {
                let uniqueChars = res.map((term) => term.name[0])
                uniqueChars = uniqueChars.filter(
                    (char, index) => uniqueChars.indexOf(char) === index,
                )
                const terms = []
                uniqueChars.forEach((char, index) => {
                    const filteredTerms = res.filter((term) => term.name[0] === char)
                    terms.push({ id: index, char: char, terms: filteredTerms })
                })
                terms.sort((a, b) => a.char.localeCompare(b.char))
                this.setState({
                    terms: terms,
                    termsLoaded: true,
                })
            })
            .catch((e) => processError(e, this.props.history))
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        this.getTerms(lang, token)
        this.getFaq({ lang, token })
    }

    render() {
        const { t } = this.props
        return (
            <Row className="terms-row w-100 mx-0">
                <Col xs={12} className="px-30">
                    <Row>
                        <Col xs={12} md={12} className="px-0">
                            <div className="page-title">
                                <div className="float-left">
                                    <h1 className="title news-dashboard pl-0 xl-font-size">{t('terms-terms')}</h1>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={12}>
                            <div className="d-flex">
                                {
                                    this.state.termsLoaded ?
                                        this.state.terms.map((terms) => (
                                            <TermsChars
                                                key={terms.id}
                                                char={terms.char}
                                                id={terms.id}
                                                length={terms.length}
                                                props={this.props}
                                            />
                                        ))
                                        :
                                        <React.Fragment>
                                            <TermsChars skeleton={true} />
                                            <TermsChars skeleton={true} />
                                            <TermsChars skeleton={true} />
                                            <TermsChars skeleton={true} />
                                            <TermsChars skeleton={true} />
                                        </React.Fragment>

                                }
                            </div>
                        </Col>
                        <Col xs={12} md={12}>
                            <div className="row">
                                {
                                    this.state.termsLoaded ?
                                        this.state.terms.map((terms) => (
                                            <TermsCard
                                                key={terms.id}
                                                id={terms.id}
                                                char={terms.char}
                                                terms={terms.terms}
                                                props={this.props}
                                            />
                                        ))
                                        :
                                        <React.Fragment>
                                            <TermsCard skeleton={true} />
                                            <TermsCard skeleton={true} />
                                        </React.Fragment>
                                }
                            </div>
                        </Col>
                        <Col xs={12} md={12}>
                            <div className="faq-title xl-font-size">{t('terms-title')}</div>
                            <div className="faq-questions">
                                {
                                    this.state.faqLoaded ?
                                        this.state.faq.map((question) => (
                                            <Question
                                                key={question.id}
                                                id={question.id}
                                                title={question.title}
                                                content={question.content}
                                            />
                                        ))
                                        :
                                        <Question skeleton={true} />
                                }
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }
}

Terms.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Terms)



// WEBPACK FOOTER //
// ./src/views/Terms/Terms.jsx